import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';
import { Image as SemanticImage } from 'semantic-ui-react';
import meetingsSrc from 'assets/media/eden/my-workspace/meetings.jpeg';
import styles from '../styles.module.scss';

export const Meetings = () => (
  <>
    <SemanticImage
      src={meetingsSrc}
      alt="Meetings"
      className={styles.image}
    />

    <Text size={16}>
      <FormattedMessage
        id="meetingsDescription"
        values={{
          bold: (...chunks) => (
            <Text
              size={16}
              element="span"
              bold
            >
              {chunks}
            </Text>
          ),
        }}
      />
    </Text>
  </>
);
